import { render, staticRenderFns } from "./ShopCartPage.vue?vue&type=template&id=4cc555cc&scoped=true&"
import script from "./ShopCartPage.vue?vue&type=script&lang=js&"
export * from "./ShopCartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc555cc",
  null
  
)

export default component.exports